import { render, staticRenderFns } from "./ElButtonDanger.vue?vue&type=template&id=22fd4cae&scoped=true&"
import script from "./ElButtonDanger.vue?vue&type=script&lang=js&"
export * from "./ElButtonDanger.vue?vue&type=script&lang=js&"
import style0 from "./ElButtonDanger.vue?vue&type=style&index=0&id=22fd4cae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fd4cae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
